/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungserstellAntragDto } from '../../models/buchungserstell-antrag-dto';
import { CreateBuchungserstellAntragDto } from '../../models/create-buchungserstell-antrag-dto';

export interface CreateBuchungserstellAntrag$Json$Params {

/**
 * ID des Mitarbeiter, für den der Antrag erstellt werden soll
 */
  mitarbeiterId: string;
  
    /**
     * Daten für den Erstellantrag
     */
    body?: CreateBuchungserstellAntragDto
}

export function createBuchungserstellAntrag$Json(http: HttpClient, rootUrl: string, params: CreateBuchungserstellAntrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
  const rb = new RequestBuilder(rootUrl, createBuchungserstellAntrag$Json.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungserstellAntragDto>;
    })
  );
}

createBuchungserstellAntrag$Json.PATH = '/v1/buchungen/{mitarbeiterId}/erstellAntrag';
